module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auto-textarea-wrapper",
    style: ({
      fontSize: _vm.fontSize,
      lineHeight: _vm.lineHeight,
      height: _vm.fullHeight ? '100%' : 'auto'
    })
  }, [_c('pre', {
    staticClass: "auto-textarea-block",
    style: ({
      fontSize: _vm.fontSize,
      lineHeight: _vm.lineHeight,
      minHeight: _vm.fullHeight ? '100%' : 'auto'
    })
  }, [_c('br'), _vm._v(_vm._s(_vm.temp_value) + " ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.temp_value),
      expression: "temp_value"
    }],
    ref: "vTextarea",
    staticClass: "auto-textarea-input",
    class: {
      'no-border': !_vm.border, 'no-resize': !_vm.resize
    },
    style: ({
      fontSize: _vm.fontSize,
      lineHeight: _vm.lineHeight
    }),
    attrs: {
      "autofocus": _vm.s_autofocus,
      "spellcheck": "false",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.temp_value)
    },
    on: {
      "keyup": _vm.change,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.temp_value = $event.target.value
      }
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7b6fd5e4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b6fd5e4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/auto-textarea/auto-textarea.vue
// module id = 219
// module chunks = 0